module.exports = {
      id: "nagorik-usage",
      viewBox: "0 0 336 47",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#nagorik",
      toString: function () {
        return this.url;
      }
    }